import DuraflowCategoryPage from '@/pages/equipamentos-e-componentes/components/DuraflowCategoryPage';
import useSeo from '@/hooks/useSeo';

export default function CilindrosPage() {
  useSeo({
    title: 'Cilindros Hidráulicos Industriais | Duraflow',
    description: 'Cilindros de duplo efeito, simples efeito, telescópicos, alta pressão e sob medida para aplicações industriais e móveis.',
    keywords: 'cilindros hidráulicos, cilindros de duplo efeito, cilindros telescópicos, componentes hidráulicos, DURAFLOW, Grupo Pilar',
    canonical: 'https://www.pilarmanutencao.com.br/cilindros-hidraulicos',
    ogUrl: 'https://www.pilarmanutencao.com.br/cilindros-hidraulicos',
    ogImage: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/CILINDROS-HIDRAULICOS/CARD/CILINDROS-HIDRAULICOS.webp',
  });

  return (
    <DuraflowCategoryPage
      title="CILINDROS HIDRÁULICOS"
      subtitle="Soluções para força linear, movimentação, elevação e aplicações industriais de alta exigência."
      heroImage="/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/CILINDROS-HIDRAULICOS/HERO/HERO-CILINDROS-HIDRAULICOS.webp"
      heroImageAlt="Cilindros hidráulicos industriais de alto desempenho"
      description="Cilindros hidráulicos transformam pressão hidráulica em força linear. São aplicados em máquinas, prensas, sistemas de elevação, equipamentos móveis e operações que exigem força, precisão e robustez."
      applicationsTitle="Soluções atendidas"
      applications={[
        'Cilindros de simples ação',
        'Cilindros de dupla ação',
        'Cilindros industriais',
        'Cilindros para máquinas móveis',
        'Hastes cromadas',
        'Camisas',
        'Vedações',
        'Reposição e reparo sob consulta',
      ]}
      applications2Title="Aplicações"
      applications2={[
        'Prensas hidráulicas',
        'Máquinas industriais',
        'Equipamentos agrícolas',
        'Sistemas de elevação',
        'Basculantes',
        'Máquinas móveis',
        'Plataformas',
        'Equipamentos de movimentação',
      ]}
      types={[
        {
          title: 'Cilindros de Duplo Efeito',
          description:
            'Cilindros com ação nos dois sentidos de avanço e retorno, com diâmetros de haste e tubo variados para aplicações de empurrar e puxar.',
        },
        {
          title: 'Cilindros de Simples Efeito',
          description:
            'Cilindros com retorno por mola ou carga para aplicações onde o retorno não requer força hidráulica, reduzindo consumo energético.',
        },
        {
          title: 'Cilindros Telescópicos',
          description:
            'Cilindros de múltiplos estágios para grandes curso em espaço reduzido, aplicados em caminhões, plataformas e sistemas de elevação.',
        },
        {
          title: 'Cilindros de Alta Pressão',
          description:
            'Cilindros construídos para operar em pressões superiores a 700 bar, com selagem especial e materiais de alta resistência mecânica.',
        },
        {
          title: 'Cilindros com Válvula de Segurança',
          description:
            'Cilindros equipados com válvulas anti-queda e de segurança integradas para aplicações críticas de sustentação de cargas pesadas.',
        },
        {
          title: 'Cilindros sob Medida',
          description:
            'Projeto e fabricação de cilindros customizados conforme desenho técnico do cliente, com materiais e acabamentos especiais.',
        },
      ]}
      differentialsTitle="DIFERENCIAIS DURAFLOW"
      differentials={[
        'Atendimento técnico especializado',
        'Fornecimento sob consulta',
        'Apoio na identificação de componentes',
        'Análise da aplicação',
        'Alternativas compatíveis',
        'Cotação rápida via WhatsApp',
        'Suporte para manutenção industrial',
        'Soluções para reposição e novos projetos',
      ]}
      midCTA={{
        title: 'Precisa reparar, substituir ou cotar um cilindro hidráulico?',
        text: 'Envie foto, medidas, curso, diâmetro da haste ou aplicação para análise.',
        buttonText: 'Analisar cilindro hidráulico',
      }}
      ctaTitle="Precisa de uma solução hidráulica?"
      ctaText="Envie sua demanda para nossa equipe técnica. Podemos ajudar na identificação, cotação e fornecimento do componente mais adequado para sua aplicação."
      ctaButtonText="Chamar no WhatsApp"
    />
  );
}